<template>
    <div class="card-body row m-0" v-if="!medicalReportLoading">
        <div class="col-sm-6">
            <vue-editor v-model="medicalReportText" :editorToolbar="customToolbar"></vue-editor>
            <br>
            <button v-if="medicalReportPending" class="btn btn-primary btn-sm disabled" disabled="disabled"><i class="fa fa-spinner fa-pulse fa-fw"></i> Ukládám</button>
            <button v-else-if="!medicalReportPending && medicalReportText !== medicalReportOldText" @click="saveMedicalReport" class="btn btn-sm btn-success">Uložit</button>
            <template v-else="">
                <button disabled="disabled" class="btn btn-sm btn-success disabled">Uloženo</button>
                <a class="btn btn-sm btn-success" target="_blank" role="button" :href="hostname.hostname + 'visit/' + $route.params.visitid + '/medical_report/pdf'"><i class="fa fa-print"></i> Tisknout zprávu</a>
            </template>
        </div>
        <div class="col-sm-6">
            <table class="table">
                <thead>
                <tr class="row m-0">
                    <th class="col-sm-1">

                    </th>
                    <th class="col-sm-3">Datum</th>
                    <th class="col-sm-3">Typ</th>
                    <th class="col-sm-5"></th>
                </tr>
                </thead>
                <tbody>
                <template v-for="(task, index) in tasks" class="card-text">
                    <tr class="row m-0" :class="openedTaskId === index ? 'border border-primary border-bottom-0' : ''">
                        <td class="align-middle col-sm-1">
                            <button class="btn btn-sm btn-primary" @click="openTaskId(index, task)" v-if="openedTaskId === index">-</button>
                            <button class="btn btn-sm btn-secondary" @click="openTaskId(index, task)" v-else="">+</button>
                            <!-- <visit-change-state v-on:update="getDoctorsDayTasks" :actual-state="task.state" :selected-doctor-id="task.planned_for.id" :visit-id="task.id"></visit-change-state> -->
                        </td>
                        <td class="col-sm-3">{{ task.date_cs }}</td>
                        <td class="col-sm-3">
                            <span v-if="task.type === 'lab_result'"><i class="fa fa-flask fa-lg" aria-hidden="true"></i> Laboratorní výsledek</span>
                            <span v-else=""><i class="fa fa-pencil-square-o" aria-hidden="true"></i> Lékařská zpráva</span>
                        <td class="col-sm-5"></td>
                    </tr>
                    <tr class="row m-0 border border-primary border-top-0" v-if="openedTaskId === index">
                        <td class="col-md-12" v-if="task.type === 'lab_result'">
                            <b>Laboratorní výsledek</b><br>
                            <div style="white-space: pre-wrap; font-family: monospace, monospace;" class="p-4" id="result_text" v-html="task.result">

                            </div>
                            <b>Hodnocení</b><br>
                            <div style="white-space: pre-wrap; font-family: monospace, monospace;" class="p-4" id="result_text" v-html="task.evaluation">

                            </div>
                        </td>
                        <td class="col-md-12" v-else="">
                            <b>Lékařská zpráva</b> <button class="btn btn-sm btn-primary" @click="copyAndInsertReport(task.text)">Zkopírovat</button><br>
                            <div style="white-space: pre-wrap; font-family: monospace, monospace;" class="p-4" id="result_text" v-html="task.text">

                            </div>
                            <template v-if="task.visit">
                                <div class="">
                                    <h6>Diagnózy a výkony</h6>
                                    <div>
                                        <table class="table">
                                            <tbody>
                                            <template v-for="diagnose in task.visit.diagnosis">
                                                <tr>
                                                    <td>{{ diagnose.disease.code }}</td>
                                                    <td>{{ diagnose.disease.name_cs }}</td>
                                                </tr>
                                                <template v-if="diagnose.actions.length > 0">
                                                    <template v-for="action in diagnose.actions">
                                                        <tr>
                                                            <td></td>
                                                            <td>
                                                                {{ action.operation.code }} - {{ action.operation.name }}
                                                            </td>
                                                        </tr>
                                                        <template v-if="action.zulp.length > 0">
                                                            <tr v-for="zulp in action.zulp">
                                                                <td></td>
                                                                <td>
                                                                    &nbsp;&nbsp;&nbsp;zulp: {{ zulp.amount }}x {{ zulp.medicine.label }}
                                                                </td>
                                                            </tr>
                                                        </template>
                                                        <template v-if="action.zum.length > 0">
                                                            <tr v-for="zum in action.zum">
                                                                <td></td>
                                                                <td>
                                                                    &nbsp;&nbsp;&nbsp;zum: {{ zum.amount }}x {{ zum.material.label }}
                                                                </td>
                                                            </tr>
                                                        </template>
                                                    </template>
                                                </template>
                                                <template v-else="">
                                                    <tr>
                                                        <td></td>
                                                        <td>
                                                            <i>(diagnóza nemá přidělené výkony)</i>
                                                        </td>
                                                    </tr>
                                                </template>
                                            </template>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div class="">
                                    <h6>Léčiva</h6>
                                    <div>
                                        <template v-if="task.visit.medicament.length > 0">
                                            <table class="table">
                                                <tbody>
                                                <tr v-for="m in task.visit.medicament">
                                                    <td>{{ m.medicine ? m.medicine.label : '' }} {{ m.individual_medicine ? m.individual_medicine.name : '' }}</td>
                                                    <td>{{ m.dosage }}</td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </template>
                                        <template v-else="">
                                            <i>žádný lék nepředepsán</i>
                                        </template>
                                    </div>
                                </div>
                            </template>
                        </td>
                    </tr>

                </template>
                </tbody>
            </table>
        </div>
     </div>
</template>

<script>
  import _ from 'lodash'
  import apiMixin from '@/mixins'
  import MedicalReport from './MedicalReport.vue'

  import { VueEditor } from 'vue2-editor'

  export default {
    data () {
      return {
        hostname: require('@/variables.js'),
        customToolbar: [
          ['bold', 'italic', 'underline', 'strike'],
          [{'list': 'ordered'}, {'list': 'bullet'}],
          [{'indent': '-1'}, {'indent': '+1'}],
          [{'color': []}],
          [{'align': []}]
        ],
        medicalReportText: '',
        medicalReportOldText: false,
        medicalReportLoading: false,
        medicalReportPending: false,
        medicalReportError: false,
        medicalReportChanged: false,
        //
        tasks: false,
        tasksError: false,
        tasksPending: true,
        openedTaskId: false
      }
    },
    mixins: [apiMixin],
    methods: {
      openTaskId (num, result) {
        if (this.openedTaskId === num) {
          this.openedTaskId = false
        } else {
          this.openedTaskId = num
        }
      },
      saveMedicalReport () {
        this.postMedicalReport(this.$route.params.visitid, this.medicalReportText)
      },
      copyAndInsertReport (report) {
        this.medicalReportText = report
      }
    },
    beforeMount () {
      this.getMedicalReport(this.$route.params.visitid)
      this.getMedicalReportAndLabResultOfClient(this.$store.state.clientId)
    },
    watch: {
      '$route' (to, from) {
        if (to.params.visitid !== from.params.visitid) {
          this.getMedicalReport(this.$route.params.visitid)
          this.getMedicalReportOfClient(this.$store.state.clientId)
          this.isChanged = false
          this.getVisit()
        }
      },
      medicalReportText: _.debounce(function (newVal) {
        this.saveMedicalReport()
      }, 1000)
    },
    components: {
      MedicalReport,
      VueEditor
    },
    beforeRouteLeave (to, from) {
      this.saveMedicalReport()
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Visit/components/MedicalReport.vue?6920178e